var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.8,
    height: 21.653,
    viewBox: "0 0 19.8 21.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1230",
    transform: "translate(-1191 -27)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "M16.678 18.7H1.028a1.008 1.008 0 0 1-.952-.632.989.989 0 0 1 .23-1.1l1.331-1.3V9.6a6.992 6.992 0 0 1 1.622-4.461A7.25 7.25 0 0 1 7.311 2.7V1.517a1.548 1.548 0 0 1 3.1 0V2.7c.19.04.379.089.561.143a5 5 0 0 0 4.288 7.571 5.055 5.055 0 0 0 .824-.068v5.322l1.331 1.3a.986.986 0 0 1 .23 1.094 1.017 1.017 0 0 1-.967.638z",
    transform: "translate(1191 27)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.968 1.968A1.967 1.967 0 0 0 3.937 0H0a1.967 1.967 0 0 0 1.968 1.968z",
    transform: "translate(1197.889 46.684)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1202.8 27.9)",
    style: {
      fill: "#e30773"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.4d6a9967882fcacc792ee8572e4d073a.svg";
export { ForwardRef as ReactComponent };